import { render, staticRenderFns } from "./EditBranch.vue?vue&type=template&id=7b76739e&scoped=true&"
import script from "./EditBranch.vue?vue&type=script&lang=ts&"
export * from "./EditBranch.vue?vue&type=script&lang=ts&"
import style0 from "./EditBranch.vue?vue&type=style&index=0&id=7b76739e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b76739e",
  null
  
)

export default component.exports